import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { isAuthenticated as isAuthenticatedFn } from '../../services/auth/api';

interface Props {
  children: React.ReactElement;
}

const PrivateRoute = ({ children }: Props) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    async function effect() {
      setLoading(true);
      setIsAuthenticated(await isAuthenticatedFn());
      setLoading(false);
    }

    effect();
  }, []);

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={{ pathname: '/login', search: `?next=${location.pathname}` }} replace />;
  }

  return children;
};

export default PrivateRoute;
